export default __webpack_public_path__ + "static/media/icon_va_active_new.a00fa678.svg";